<template>
  <multiselect
    v-model="localValue"
    :options="options"
    :multiple="true"
    :group-label="groupLabel || ''"
    :group-values="groupValues || ''"
    :placeholder="placeholder || null"
    :select-label="texts.selectLabel"
    :select-group-label="texts.selectGroupLabel"
    :selected-label="texts.selectedLabel"
    :deselect-label="texts.deselectLabel"
    :deselect-group-label="texts.deselectGroupLabel"
    :aria-labelledby="ariaLabelledby"
    @select="$emit('select', $event)"
    @remove="$emit('remove', $event)"
  >
    <template #noResult>
      <div class="multiselect__option" v-text="texts.noResults" />
    </template>
    <template #option="props">
      <span v-html="highlightPhrase(props.option, props.search)"></span>
    </template>
  </multiselect>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Multiselect from 'vue-multiselect';

export default defineComponent({
  name: 'MultiSelect',

  components: {
    Multiselect,
  },

  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: '',
    },
    groupLabel: {
      type: String,
      default: '',
    },
    groupValues: {
      type: String,
      default: '',
    },
    ariaLabelledby: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      texts: theme_vars.multiselectTexts,
    };
  },

  emits: ['update:modelValue', 'select', 'remove'],

  computed: {
    localValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    },
  },

  methods: {
    highlightPhrase(option: string | object, search: string) {
      if (!option) {
        return '';
      }

      if (typeof option !== 'string') {
        return option.$isLabel ? option.$groupLabel : '';
      }

      if (!search) {
        return option;
      }

      const searchRegex = new RegExp(`(${search})`, 'gi');
      return option.replace(searchRegex, '<strong>$1</strong>');
    },
  },
});
</script>
